export default function textTruncate (value, cnt) {
  if (value.length && value.substring) {
    return value.length > cnt ? value.substring(0, cnt) + '...' : value
  }
  console.error('textTruncate只接受string, 实际接收到:', value)
  return value
}
